import { render, staticRenderFns } from "./BookingReport.vue?vue&type=template&id=18e7366e&"
import script from "./BookingReport.vue?vue&type=script&lang=js&"
export * from "./BookingReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports